import styled from 'styled-components';

export const PaginatorWrapper = styled.div`
  display: flex;
  align-items: center;
`;
